module.exports = __webpack_public_path__ + "08d6e7ed5e32874f1894b29231f781a6.svg";